// ReturnProducts.tsx
import React, { useState } from "react";
import { Search, Plus, Minus } from "lucide-react";
import { SelectedProduct } from "./ReturnMain";

interface ReturnProductsProps {
  returnProducts: SelectedProduct[];
  onUpdateQuantity: (productId: string, change: number) => void;
  onRemoveProduct: (productId: string) => void;
}

const ReturnProducts: React.FC<ReturnProductsProps> = ({
  returnProducts,
  onUpdateQuantity,
  onRemoveProduct,
}) => {
  console.log("returnProducts", returnProducts);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredProducts = returnProducts.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const calculateReturnTotal = () => {
  const total = returnProducts.reduce(
    (total, product) => total + product.spPerTablet * product.noOfItems,
    0
  );
  return Math.round(total); // Rounds to nearest integer
};

  return (
    <div className="bg-white rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-800">Return Product</h2>
        <div className="relative">
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-2 font-medium text-gray-600">
                Product Name
              </th>
              <th className="text-left py-3 px-2 font-medium text-gray-600">
                Price
              </th>
              <th className="text-left py-3 px-2 font-medium text-gray-600">
                Quantity
              </th>
              <th className="text-left py-3 px-2 font-medium text-gray-600">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.map((product) => (
              <tr
                key={product.inwardStockId}
                className="border-b border-gray-100 hover:bg-gray-50"
              >
                <td className="py-4 px-2">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-10 h-10 object-contain"
                      />
                    </div>
                    <div>
                      <div className="font-medium text-gray-900">
                        {product.name}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="py-4 px-2">
                  <div className="font-medium">
                    ₹ {(product.spPerTablet * product?.noOfItems).toFixed(2)}
                  </div>
                  <div className="text-sm text-gray-500">
                    ₹ {product?.spPerTablet?.toFixed(2)} each
                  </div>
                </td>
                <td className="py-4 px-2">
                  <div className="flex items-center space-x-2">
                    <button
                      onClick={() => onUpdateQuantity(product.inwardStockId, -1)}
                      className="w-6 h-6 rounded-full border border-gray-300 flex items-center justify-center bg-gray-300"
                      disabled={product.noOfItems <= 1}
                    >
                      <Minus className="h-4 w-4" />
                    </button>
                    <span className="w-8 text-center">{product.noOfItems}</span>
                    <button
                      onClick={() => onUpdateQuantity(product.inwardStockId, 1)}
                      className="w-6 h-6 rounded-full bg-green-700 text-white flex items-center justify-center"
                    >
                      <Plus className="h-4 w-4" />
                    </button>
                  </div>
                </td>
                <td className="py-4 px-2">
                  <button
                    onClick={() => onRemoveProduct(product.inwardStockId)}
                    className="px-3 py-1 bg-red-100 text-red-600 border border-red-200 rounded-full text-sm hover:bg-red-200"
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
            {filteredProducts.length === 0 && (
              <tr>
                <td colSpan={4} className="py-8 text-center text-gray-500">
                  No products in return list
                </td>
              </tr>
            )}
            {filteredProducts.length > 0 && (
              <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                <div className="flex justify-between items-center">
                  <span className="font-medium">Total Items:</span>
                  <span>
                    {returnProducts.reduce((total, p) => total + p.noOfItems, 0)}
                  </span>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <span className="font-medium">Return Amount:</span>
                  <span className="">
                    ₹
                    {calculateReturnTotal().toFixed(2)}
                  </span>
                </div>
              </div>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReturnProducts;
